import getParent from '../selectors';

export default state => getParent(state).dataSet;

export const getPagination = state => getParent(state).dataSet.pagination;
export const getPageIndex = state => getParent(state).dataSet.pageIndex;

export const getTypeOfUploadDataset = state => getParent(state).dataSet.typeOfUploadDataset;
export const isErrorTypeOfUploadDataset = state => getParent(state).dataSet.isErrorType;
